import { render, staticRenderFns } from "./commExamDetail.vue?vue&type=template&id=689255ba&scoped=true"
import script from "./commExamDetail.vue?vue&type=script&lang=js"
export * from "./commExamDetail.vue?vue&type=script&lang=js"
import style0 from "./commExamDetail.vue?vue&type=style&index=0&id=689255ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689255ba",
  null
  
)

export default component.exports